module.exports = __webpack_public_path__ + "static/media/course.e8c78f47.jpeg";